import { BoardHeader } from '@/pages/board/_components/boardHeader'
import { BlogEditor } from './blogEditor'
import { getHeaderTitle } from '@/pages/board/boardItem'
import { useResponsive } from '@/hooks/useResponsive'

export const InsertBlog = () => {
  const headerTitle = getHeaderTitle(window.location.pathname)
  const { isMobile, isTablet, isDesktop } = useResponsive()
  return (
    <>
      {!isMobile && <BoardHeader title={headerTitle} />}
      <BlogEditor />
    </>
  )
}
